import useRateAndSellCount from 'hooks/useRateAndSellCount';
import useUrl from 'hooks/useUrl';
import Dian from 'icons/store-icon.svg';
import wjz from 'images/wjz.png';
import wjzW from 'images/wjzw';
import { DeviceContext, PriceContext, SiteContext } from 'libs/contexts';
import { SITE_MODE } from 'libs/enums';
import { webps } from 'libs/imgs';
import { formatPrice } from 'libs/utils';
import Link from 'next/link';
import { useContext } from 'react';
import { Image as VantImage } from 'react-vant';
import { cls } from 'reactutils';
import { H5ProductPrice } from './ProductPrice';

webps[wjz] = wjzW;

export type MaterialsCardProps<T = string> = {
  isRecormend: boolean;
  skuDetail: T;
  sysNo: T;
  name: T;
  lowestPrice: T | number;
  highestPrice: T | number;
  unit: T;
  sourceType?: number;
  formulaModel?: T;
  mainImage: T;
  url?: any;
  style?: any;
  href: string;
  images: T[];
  bestSkuSysNo?: T;
  skuCount: number;
  shopName: T;
  hideShop?: boolean | string;
  upstreamSupplierName?: string | null;
  sellCountString?: string;
  productTagServiceList?: { tagName: string }[];
  productTagImageList?: { tagName: string }[];
  productTagTitleList?: { tagName: string }[];
  noShopCardHeight?: number;
  data: any;
};

export default function MaterialsCard({
  isRecormend, // 是否详情页推荐模块，推荐模块不展示协议价
  skuDetail,
  name,
  lowestPrice,
  unit,
  mainImage,
  style,
  href,
  cardClick,
  // highestPrice,
  skuCount,
  shopName,
  hideShop,
  sellCountString,
  upstreamSupplierName,
  productTagServiceList,
  productTagImageList,
  productTagTitleList,
  noShopCardHeight = 288,
}: MaterialsCardProps & { cardClick?: Function }) {
  const { buildImgSrc } = useContext(DeviceContext);
  const site = useContext(SiteContext);
  // const longNum = (L: string, H: string) => L.length < 3 && H.length < 3
  // const siteConfig = useContext(SiteContext);
  const { showPrice, tip } = useContext(PriceContext);
  const { canView } = useRateAndSellCount();
  const { getPublicUrl } = useUrl();
  const handlePrice = (low: number) => {
    return (
      <span className="number">
        <span className="integer">{formatPrice(low)}</span>
      </span>
    );
  };
  const record = () => cardClick?.();
  return (
    <>
      <Link href={href}>
        <a>
          <div
            className={cls('box', hideShop && 'hide-shop')}
            style={style}
            onClick={() => record()}
          >
            <VantImage
              src={getPublicUrl(mainImage)}
              alt={name}
              height={169}
              loadingIcon={buildImgSrc(wjz)}
            />
            {productTagImageList?.[0] && (
              <span className="img-tag">{productTagImageList?.[0].tagName}</span>
            )}
            <div className="content">
              {productTagTitleList?.[0] ? (
                <div className={cls('name')}>
                  <span className="title-tag">{productTagTitleList?.[0].tagName}</span> {name}
                </div>
              ) : (
                <div className={cls('name')}>{name}</div>
              )}
              {!isRecormend && <H5ProductPrice data={skuDetail} />}
              {/* 价格展示优化逻辑 20231030*/}
              {isRecormend && (
                <div className="price">
                  <span className="unit">￥</span>{' '}
                  {showPrice ? (
                    <>
                      {handlePrice(Number(lowestPrice))}
                      <span className="unit"> /{unit}</span>
                    </>
                  ) : (
                    tip
                  )}
                </div>
              )}
              {/* 价格展示 */}
              {canView ? (
                <div className={cls('model-with-sellCount ellipsis')}>
                  <span>{skuCount}个规格</span>
                  <span className="sellCount">销量{sellCountString}</span>
                </div>
              ) : (
                <div className={cls('model')}>{skuCount}个规格</div>
              )}
              {site?.mall?.enableSelfSiteMode === SITE_MODE.SHOP && !hideShop && (
                <div className={cls('shop')}>
                  <Dian />
                  {shopName}
                </div>
              )}
              <div className="deliver-box">
                {upstreamSupplierName && (
                  <div className="content-delivery">
                    由<span className="content-delivery-name">{upstreamSupplierName}</span>
                    配送
                  </div>
                )}
              </div>
              {productTagServiceList?.length > 0 && (
                <div className="tag-wrap">
                  {productTagServiceList?.map((v, i) => (
                    <span key={i} className="tag-span">
                      <span className="border-item" />
                      <span className="tag-name">{v.tagName}</span>
                    </span>
                  ))}
                </div>
              )}
            </div>
          </div>
        </a>
      </Link>
      <style jsx>
        {`
          .box {
            height: 327px;
            background: #ffffff;
            box-shadow: 0 1px 7px 3px rgba(184, 184, 184, 0.06);
            border-radius: 3px;
            width: calc((100vw - 37px) / 2);
            position: relative;
          }
          .hide-shop {
            height: ${noShopCardHeight - 5}px !important;
          }
          .materialsImg {
            width: 100%;
            height: 169px;
            display: block;
            object-fit: contain;
          }
          .content {
            padding: 10px;
          }
          .name {
            font-size: 14px;
            color: #666666;
            letter-spacing: 0;
            text-align: justify;
            line-height: 18px;
            font-weight: 400;
            width: 149px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            height: 36px;
          }
          .price {
            margin-top: 3px;
            font-size: 12px;
            color: #ff6602;
            margin-left: -1px;
          }
          .tag {
            height: 16px;
            line-height: 16px;
            background: rgba(252, 145, 5, 0.1);
            border: 1px solid #ffc89a;
            color: #fc9105;
            font-size: 11px;
            padding: 0 5px;
            border-radius: 2px;
            display: initial;
          }
          .box :global(.integer) {
            font-size: 14px;
          }
          .box :global(img) {
            border-radius: 3px;
          }
          .mt3 {
            margin-top: 3px;
            display: inline-block;
          }
          .unit {
            font-weight: normal;
            font-size: 12px;
          }
          .box :global(.number) {
            font-family: "wowbold";
            font-size: 12px;
            font-weight: bold;
          }
          .model {
            font-size: 12px;
            color: #999999;
            height: 16px;
            line-height: 16px;
            width: 125px;
            margin-top: 3px;
            margin-bottom: 3px;
          }
          .model-with-sellCount {
            width: 100%;
            max-width: 100%;
            font-size: 12px;
            color: #999999;
            height: 16px;
            line-height: 16px;
            margin-top: 3px;
            margin-bottom: 3px;
          }
          .sellCount {
            float: right;
          }
          .shop {
            font-size: 11px;
            color: #999999;
            padding-left: 2px;
            width: 149px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
          }
          .shop :global(svg) {
            transform: scale(0.8) translate(-2px, 4px);
          }
          .hideLine {
            text-decoration: none;
          }
          .hide-shop {
          }
          .content-delivery {
            display: flex;
            color: #666;
            font-size: 11px;
            white-space: nowrap;
          }
          .content-delivery-name {
            padding: 0 5px;
            color: #999;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .tag-wrap {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            height: 20px;
            line-height: 20px;
            display: inline-block;
            max-width: 100%;
            color: #f5222d;
            position: relative;
            margin-top: 2px;
            transform: translateX(-2px);
          }
          .tag-wrap::after {
            content: "";
            position: absolute;
            right: 2px;
            width: 1px;
            top: 3px;
            height: 16px;
            background: #f5222d;
            transform: scale(0.9);
          }
          .border-item {
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            border: 1px solid #f5222d;
          }
          .tag-span {
            padding: 2px;
            border-radius: 1px;
            font-size: 12px;
            color: #f5222d;
            line-height: 1;
            margin-right: 2px;
            position: relative;
            transform: scale(0.9);
            display: inline-block;
          }
          .tag-span:last-child {
            border-right: none;
            margin-right: 0;
          }
          .tag-span:last-child .border-item {
            border-right: none;
          }
          .tag-name {
            transform: scale(calc(11 / 12));
            display: inline-block;
          }
          .img-tag {
            position: absolute;
            top: 0;
            left: 0;
            background: #f5222d;
            border-radius: 3px 0 0 0;
            padding: 0px 3px;
            color: #fff;
            font-size: 12px;
            line-height: 15px;
          }
          .title-tag {
            padding: 0px 2px;
            background: var(--primaryColor);
            border-radius: 1px;
            color: #fff;
            font-size: 11px;
            margin-right: 2px;
            display: inline-block;
            transform: translateY(-1px);
            line-height: 15px;
          }
          .deliver-box {
            height: 18px;
          }
        `}
      </style>
    </>
  );
}
